import { useReducer, useEffect } from "react";
import { AuthContext } from "./auth/AuthContext";
import { authReducer } from "./auth/authReducer";
import { readToken } from "./helpers/readToken";
import AppRouter from "./routers/AppRouter";
import { types } from "./types/types";

import './App.css'

/* eslint-disable no-unused-vars */
import montserrat from '@fontsource/montserrat'
import raleway from '@fontsource/raleway'
import lora from '@fontsource/lora'
/* eslint-enable no-unused-vars */

function App() {
  
  const [user, dispatch] = useReducer(authReducer, null)

  useEffect(() => {

    const verify = async() => {

      const user = await readToken();
      if ( !user ) { return dispatch({ type: types.logout }) }

      dispatch({ type: types.login , payload: user });

    }

    verify();

  },[])

  return (
    
    <AuthContext.Provider value={{ user, dispatch }}>
      <AppRouter />
    </AuthContext.Provider>

  );
}

export default App;
